module.exports = __webpack_public_path__ + "img/product_14.16e4584.webp";